// extracted by mini-css-extract-plugin
export default {"TabContainer":"style_TabContainer__ru8ty","tab":"style_tab__unMJV","activeTab":"style_activeTab__pKsXz"};